let listeners = [];
let requestCount = 0;

export const subscribeSpinner = (listener) => {
  listeners.push(listener);

  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
};

const notify = (isLoading) => {
  listeners.forEach((listener) => listener(isLoading));
};

export const startRequest = () => {
  requestCount++;
  notify(true);
};

export const endRequest = () => {
  requestCount--;

  if (requestCount <= 0) {
    requestCount = 0;
    notify(false);
  }
};